import { AxiosInstance, AxiosRequestConfig } from 'axios';
import axios from 'axios';

import { jwtStore } from '../../stores/JwtStore';

/**
 * Default timeout = 5 seconds
 */
const timeout = 1000 * 5;

/**
 * Default headers
 */
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

/**
 * Default base URL
 */
const baseURL = process.env.REACT_APP_BASE_API_URL;
if (!baseURL) {
  throw new Error('API endpoint could not be found');
}

class Request {
  /**
   * Axios instance.
   */
  private axiosInstance: AxiosInstance;

  public constructor() {
    this.axiosInstance = axios.create({ baseURL, headers, timeout });
  }

  public get(url: string, config?: AxiosRequestConfig) {
    this.updateHeader();
    return this.axiosInstance.get(url, config);
  }

  public post(url: string, data?: any, config?: AxiosRequestConfig) {
    this.updateHeader();
    return this.axiosInstance.post(url, data, config);
  }

  public put(url: string, data?: any, config?: AxiosRequestConfig) {
    this.updateHeader();
    return this.axiosInstance.put(url, data, config);
  }

  public patch(url: string, data?: any, config?: AxiosRequestConfig) {
    this.updateHeader();
    return this.axiosInstance.patch(url, data, config);
  }

  public delete(url: string, config?: AxiosRequestConfig) {
    this.updateHeader();
    return this.axiosInstance.delete(url, config);
  }

  /**
   * Check if an JWT token is attached to the header of this Axios instance
   */
  public hasJwtToken(): boolean {
    return !!jwtStore.rawToken;
  }

  /**
   * Update JWT in header.
   */
  private updateHeader(){
    if (jwtStore.rawToken) {
      this.axiosInstance.defaults.headers.common.Authorization = `JWT ${jwtStore.rawToken}`;
    } else {
      delete this.axiosInstance.defaults.headers.common.Authorization;
    }
  }
}

export default new Request();



// WEBPACK FOOTER //
// ./src/common/utils/Request.ts